import React, { useState } from 'react';
import { ChangeForm } from 'js/components/common/ChangeForm';
import { componentService } from 'js/services/component.service';
import { withComponent } from 'js/components/hocs/withComponent';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as hooks from './hooks';
import * as Types from './types';
import { DYNAMIC_FORGOT_EMAIL, DEFAULT_STEP_1_FORM_NAME, DEFAULT_STEP_2_FORM_NAME } from './constants';

import style from './DynamicForgotEmail.scss';

export const DynamicForgotEmailBare: React.FC = () => {
    const [userEmail, setUserEmail] = useState<string>('');
    const [token, setToken] = useState<string>('');
    const { formName1, formName2 } = useComponentConfig<Types.IDynamicForgotEmailComponentConfig>();
    const translate = useComponentTranslations();
    const startForgotEmail = hooks.useStartForgotEmail({ setToken });
    const completeForgotEmail = hooks.useCompleteForgotEmail({ token, setUserEmail });

    if (userEmail) {
        return <p className={style.userEmail}>{translate('successMessage', [userEmail])}</p>;
    }

    if (token) {
        return (
            <ChangeForm
                key="step2"
                onSubmit={completeForgotEmail}
                formName={formName2 || DEFAULT_STEP_2_FORM_NAME}
            />
        );
    }

    return (
        <ChangeForm
            key="step1"
            validationOperation="forgotEmail"
            onSubmit={startForgotEmail}
            formName={formName1 || DEFAULT_STEP_1_FORM_NAME}
        />
    );
};

export const DynamicForgotEmail = withComponent({
    isForLoggedOut: true,
    tkPrefix: 'playtech.mobile.system.dynamic-forgot-email.'
})(DynamicForgotEmailBare);

componentService.registerPageComponents({ [DYNAMIC_FORGOT_EMAIL]: DynamicForgotEmail });
